import { Injectable } from '@angular/core';
import { ADMIN_ROLES } from '../enums/adminRoles';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  constructor() { }


  isAdmin = (claims: any): boolean => {
    return (claims.isAdmin && claims.isActive) || claims.roles.includes(ADMIN_ROLES.owner);
  }

  canViewAdmins = (claims: any): boolean => {
    return (this.isAdmin(claims) && (claims.roles.includes(ADMIN_ROLES.canManageAdmins)));
  }
  canViewMembers = (claims: any): boolean => {
    return (this.isAdmin(claims) && (claims.roles.includes(ADMIN_ROLES.canManageMembers)));
  }
  canViewLoans = (claims: any): boolean => {
    return (this.isAdmin(claims) && (claims.roles.includes(ADMIN_ROLES.canManageLoans)));
  }
  canViewSavings = (claims: any): boolean => {
    return (this.isAdmin(claims) && (claims.roles.includes(ADMIN_ROLES.canManageSavings)));
  }
  canViewAccounting = (claims: any): boolean => {
    return (this.isAdmin(claims) && (claims.roles.includes(ADMIN_ROLES.canManageAccounting)));
  }

  canViewSettings = (claims: any): boolean => {
    return (this.isAdmin(claims) && (claims.roles.includes(ADMIN_ROLES.canManageAdmins)));
  }

  canViewMessaging = (claims: any): boolean => {
    return (this.isAdmin(claims) && (claims.roles.includes(ADMIN_ROLES.canManageMessages)));
  }

}
